var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageSource),expression:"imageSource"}],staticClass:"w-100",staticStyle:{"object-fit":"cover"},attrs:{"src":_vm.imageSource,"alt":_vm.image.name}})}
var staticRenderFns = []

export { render, staticRenderFns }